module.exports = __webpack_public_path__ + "static/slide-4-e78c9cf2ff2f08399e7ea5f43210541b.png";